export default __webpack_public_path__ + "static/media/flight.93580532.svg";